import { useModuleBEM } from "@b2bportal/core-themes";
import {
  LanguageSelect,
  LanguageSelectType,
  useI18nContext,
} from "@hopper-b2b/i18n";
import { MobileNavigation as CoreMobileNavigation } from "@hsbc/core-portal";
import styles from "./styles.module.scss";

export const MobileNavigation = ({ className }: { className?: string }) => {
  const { language, brand } = useI18nContext();
  const [, cn] = useModuleBEM(styles, "NavigationContent");

  return (
    <CoreMobileNavigation className={className}>
      {/* This is purely for testing, not final design or code */}
      <div className={cn("language-select-wrapper")}>
        <LanguageSelect
          type={LanguageSelectType.FORM}
          defaultLocale={language}
          supportedLanguages={brand?.supportedLanguages}
        />
      </div>
    </CoreMobileNavigation>
  );
};
